// **MidtermPriceBox (Main Container)**
import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useOpenLoginModal } from '@/hooks/useOpenLoginModal';
import { setBasicFilters } from '@/redux/store/actions/search';
import ReservationDetailsDrawer from './reservationDetailsDrawer/ReservationDetailsDrawer';
import CalendarModal from './calendarModal/CalendarModal';
import Box from '@/components/UI/box/Box';
import Button from '@/components/UI/button/Button';
import styles from './MidtermPriceBox.module.scss';
import RequestDrawer from './requestDrawer/RequestDrawer';
const MidtermPriceBox = ({
  data,
  onSendReserveRequestClick,
  loading
}) => {
  const dispatch = useDispatch();
  const {
    setLoginDrawerState
  } = useOpenLoginModal();
  const {
    checkin,
    checkout,
    guests
  } = useSelector(state => state.basicFilters);
  const {
    bootstrapData,
    requestToVisit
  } = useSelector(state => ({
    bootstrapData: state.bootstrapData,
    requestToVisit: state.requestToVisit
  }));
  const [openFactor, setOpenFactor] = useState(false);
  const [open, setOpen] = useState({
    reserve: false,
    visit: false
  });
  const calendarRef = useRef();
  const hasActiveRequest = data?.has_active_request || requestToVisit.data;
  const isLoggedIn = !!bootstrapData?.data?.user_info?.uid;
  const maxAccommodates = data?.rules?.records?.max_accommodates;
  const baseAccommodates = data?.rules?.records?.accommodates;
  const haveActiveRequset = useRef(false);
  const haveActiveReserveRequest = useRef(false);
  const handleReserve = () => {
    if (!isLoggedIn) {
      setLoginDrawerState({
        open: true,
        message: 'برای ادامه لطفا وارد شوید.'
      });
      haveActiveRequset.current = true;
    } else {
      setOpen(prev => ({
        ...prev,
        reserve: true
      }));
    }
  };
  const requestForVisit = () => {
    if (!isLoggedIn) {
      setLoginDrawerState({
        open: true,
        message: 'برای ادامه لطفا وارد شوید.'
      });
      haveActiveReserveRequest.current = true;
    } else {
      setOpen(prev => ({
        ...prev,
        visit: true
      }));
    }
  };
  useEffect(() => {
    if (isLoggedIn && haveActiveRequset.current) {
      setOpen(prev => ({
        ...prev,
        reserve: true
      }));
    }
    if (isLoggedIn && haveActiveReserveRequest.current) {
      setOpen(prev => ({
        ...prev,
        visit: true
      }));
    }
  }, [isLoggedIn]);
  const handleDatepickerChange = dates => {
    dispatch(setBasicFilters({
      checkin: dates.checkin,
      checkout: dates.checkout,
      guests: guests || 1
    }));
  };
  return <>
      <RequestDrawer open={open.visit} onClose={() => setOpen(prev => ({
      ...prev,
      visit: false
    }))} data-sentry-element="RequestDrawer" data-sentry-source-file="MidtermPriceBox.tsx" />
      <ReservationDetailsDrawer open={openFactor} onClose={() => setOpenFactor(false)} checkin={checkin} checkout={checkout} guests={guests} loading={loading} onSendReserveRequestClick={onSendReserveRequestClick} maxAccommodates={maxAccommodates} baseAccommodates={baseAccommodates} handleDateChange={() => {
      setOpenFactor(false);
      setOpen(prev => ({
        ...prev,
        reserve: true
      }));
    }} handleStepperChange={type => {
      let count = Number(guests);
      dispatch(setBasicFilters({
        checkin,
        checkout,
        guests: type === 'increase' ? ++count : --count
      }));
    }} data-sentry-element="ReservationDetailsDrawer" data-sentry-source-file="MidtermPriceBox.tsx" />
      <CalendarModal open={open.reserve} onClose={() => setOpen(prev => ({
      ...prev,
      reserve: false
    }))} handleDatePickerChange={handleDatepickerChange} calendarRef={calendarRef} minDays={data?.pricing?.records[0]?.mid_term_minimum_days} onSubmit={() => {
      setOpenFactor(true);
      setOpen(prev => ({
        ...prev,
        reserve: false
      }));
    }} data-sentry-element="CalendarModal" data-sentry-source-file="MidtermPriceBox.tsx" />
      <Box className={styles['midterm-container']} data-sentry-element="Box" data-sentry-source-file="MidtermPriceBox.tsx">
        <Button onClick={handleReserve} format="primary" data-sentry-element="Button" data-sentry-source-file="MidtermPriceBox.tsx">
          ثبت رزرو
        </Button>
      </Box>
    </>;
};
export default MidtermPriceBox;